import React, { Component } from 'react';
import { ErrorMessage, Field, Form, Formik } from 'formik';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import CustomLoader from '../../../common/CustomLoader';
import * as actions from '../../../../features/events/redux/actions';
import { validateSubmitBtn } from '../../ActionFormUtils';
import ConsoleLogOptions from '../../ConsoleLogOptions';
import FormFieldWithLabel from '../../../common/FormFieldWithLabel';
import BrowserStorageLocationField from '../BrowserStorageLocationField';
import { iconForField } from '../../../../common/custom/icon-library';
import TooltipInfo from '../../../../common/docs/TooltipInfo';
class BrowserStorageActionForm extends Component {
  state = {
    showCLOption: false,
  };

  createActionSettingsSchema = (actionData, eventAction) => {
    let schema = {};
    actionData.args.forEach((args) => {
      const dbParameters = eventAction.parameters.find((param) => {
        return param.name === args.name;
      });
      if (dbParameters) {
        schema[args.name] = dbParameters ? dbParameters.value : '';
      } else {
        schema[args.name] = args.value || '';
      }
    });
    return schema;
  };

  handleSubmit = (values) => {
    const { actionData, version, projectId, actions, selectedEvent } = this.props;
    let parameters = [];
    Object.keys(values).map((value) => {
      const action = actionData.args.find((param) => {
        return param.name === value;
      });
      parameters.push({ name: value, value: values[value], type: action.type });
    });
    let actionFormData = this.props.eventAction;
    actionFormData.parameters = parameters;
    actions.updateAction({
      projectId,
      version,
      eventId: selectedEvent.uuid,
      data: actionFormData,
    });
    this.props.hideModal();
  };

  validateCustomJsonKey = (value) => {
    let error;
    if (!value) {
      error = "Custom JSON Key can't be blank";
    } else if (!/^[^_][A-Za-z_0-9]+$/i.test(value)) {
      error = 'Custom JSON Key should not contain special characters';
    } else if (value.length > 50) {
      error = 'Custom JSON Key can not be more than 50 characters';
    }
    return error;
  };

  validateCustomJsonValue = (value) => {
    let error;
    return error;
  };

  clogOptionHandler = () => {
    this.setState({
      showCLOption: !this.state.showCLOption,
    });
  };

  render() {
    const { eventAction, actionData } = this.props;
    const { name } = eventAction;
    const { showCLOption } = this.state;

    return (
      <Formik
        enableReinitialize={true}
        initialValues={this.createActionSettingsSchema(actionData, eventAction)}
        onSubmit={(values, { setSubmitting, resetForm }) => {
          this.handleSubmit(values);
          setSubmitting(false);
          resetForm();
        }}
      >
        {({ isSubmitting, values, setFieldValue, setFieldTouched, errors, isValidating }) => (
          <Form>
            <div className="row">
              <div className="col-12">
                <BrowserStorageLocationField
                  fieldName={'browserStorageLocation'}
                  values={values}
                  setFieldValue={setFieldValue}
                  setFieldTouched={setFieldTouched}
                />
                {name === 'setBrowserStorageData' && (
                  <>
                    <div className="form-group">
                      <FormFieldWithLabel
                        cta={false}
                        label="Custom JSON Key"
                        icon="text"
                        infoIcon={true}
                        infoDescription={`Enter the key in which you want to save form submission data in your web browser storage.`}
                      >
                        <Field
                          type="text"
                          name="customJsonKey"
                          className="form-control form-control-sm"
                          autoComplete="off"
                          placeholder="Custom JSON Key"
                          validate={this.validateCustomJsonKey}
                        />
                      </FormFieldWithLabel>
                      <ErrorMessage
                        name="customJsonKey"
                        component="p"
                        className="text-error ml-5"
                      />
                    </div>
                    <div className="form-group">
                      <FormFieldWithLabel
                        cta={false}
                        label="Custom JSON Value"
                        icon="text"
                        infoIcon={true}
                        infoDescription={`Enter the key in which you want to save form submission data in your web browser storage.`}
                      >
                        <Field
                          type="text"
                          name="customJsonValue"
                          className="form-control form-control-sm"
                          autoComplete="off"
                          placeholder="Custom JSON Value"
                          validate={this.validateCustomJsonValue}
                        />
                      </FormFieldWithLabel>
                      <ErrorMessage
                        name="customJsonValue"
                        component="p"
                        className="text-error ml-5"
                      />
                    </div>
                  </>
                )}

                {name === 'clearBrowserStorageData' && (
                  <>
                    <div className="form-group">
                      <div className="input-group">
                        <div className="input-group-prepend" title="Remove All Data">
                          <span className="input-group-text">
                            <i className={`wb ${iconForField('boolean-toggle')}`}></i>
                          </span>
                        </div>
                        <div className="form-check">
                          <label className="form-check-label">
                            <Field
                              type="checkbox"
                              name="removeAllData"
                              className="form-check-input"
                              title="Remove All Data"
                              disabled={!!values['removeSelectedKeys']}
                            />
                            Remove All Data
                            <span className="form-check-sign">
                              <span className="check"></span>
                            </span>
                          </label>
                        </div>
                        <TooltipInfo
                          title={`Enable it to remove all the keys from the selected Browser Storage Location in your web browser.`}
                          headerText={`What's this ?`}
                          showHeader={true}
                          showArrow={true}
                          append={true}
                        />
                      </div>
                      <ErrorMessage
                        name="removeAllData"
                        component="p"
                        className="text-error ml-5"
                      />
                    </div>
                    <div className="form-group">
                      <FormFieldWithLabel
                        cta={false}
                        label="Remove Selected Key(s)"
                        icon="text"
                        infoIcon={true}
                        infoDescription={`Enter the key(s) separated by comma (,) which you want to remove from your web browser selected storage location.`}
                      >
                        <Field
                          type="text"
                          name="removeSelectedKeys"
                          className="form-control form-control-sm"
                          autoComplete="off"
                          placeholder="Remove Selected Key(s) Eg. Key1 or, Key1,Key2,Key3"
                          disabled={values['removeAllData']}
                        />
                      </FormFieldWithLabel>
                      <ErrorMessage
                        name="removeSelectedKeys"
                        component="p"
                        className="text-error ml-5"
                      />
                    </div>
                  </>
                )}

                <div className="form-group">
                  <button
                    onClick={(e) => this.clogOptionHandler(e)}
                    className="btn btn-icon-only btn-outline-info ml-2 p-1"
                    title="Show Console Log Options"
                    type="button"
                  >
                    <i className="wb webconnect-cog"></i>&nbsp;Console Log Options
                  </button>
                </div>
                {showCLOption && <ConsoleLogOptions values={values} />}
              </div>
            </div>

            <div className="row">
              <div className="col-md-6 text-left">
                <button
                  type="button"
                  className="btn btn-outline-secondary btn-sm"
                  onClick={this.props.hideModal}
                >
                  <span>
                    <i className="wb webconnect-times"></i> Cancel
                  </span>
                </button>
              </div>
              <div className="col-md-6 text-right">
                <button
                  type="submit"
                  disabled={validateSubmitBtn(values, eventAction)}
                  className={`btn btn-sm ${
                    validateSubmitBtn(values, eventAction) ? 'btn-default' : 'btn-theme-submit'
                  }`}
                >
                  <i className="wb webconnect-save-regular"></i>&nbsp;Save&nbsp;
                  <CustomLoader loading={this.props.showLoaderForAction} />
                </button>
              </div>
            </div>
          </Form>
        )}
      </Formik>
    );
  }
}

function mapStateToProps(state) {
  return {
    event: state.event,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(BrowserStorageActionForm);
